import { facadeApi } from 'api'

export interface Params {
  id: string
  tenantId: string
}
export const approveHubAccessRequestApi = ({ id, tenantId }: Params) =>
  facadeApi.patch('/hub-access-requests/approve/bulk', { ids: [id] }, { headers: { 'X-Tenant-Id': tenantId } })
